import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { phoneNumberSmsCapabilitiesVisitor } from '../shared/phoneNumberSmsCapabilitiesVisitor';
import { translationKeys } from '../translations';

type AdvancePaymentPhoneNumberSmsCapabilitiesNotificationProps = {
   phoneNumber: PhoneNumber | null | undefined;
};

export const AdvancePaymentPhoneNumberSmsCapabilitiesNotification = (
   props: AdvancePaymentPhoneNumberSmsCapabilitiesNotificationProps
): JSX.Element | null => {
   return phoneNumberSmsCapabilitiesVisitor(props.phoneNumber, {
      visitNotProvided: () => null,
      visitSmsCapable: () => (
         <Notification
            testId={'onlinePaymentLinkWillSendToPhoneNumber'}
            label={translationKeys.onlinePaymentLinkWillSendToPhoneNumber}
            type={NotificationType.INFO}
            size={NotificationSize.SMALLER}
         />
      ),
      visitSmsIncapable: () => (
         <Notification
            testId={'unsupportedPhoneNumberForSendingLink'}
            label={translationKeys.unsupportedPhoneNumberForSendingLink}
            type={NotificationType.WARNING}
            size={NotificationSize.SMALLER}
         />
      ),
   });
};
